export class RecentItem {
  componentId: number;
  cssColor: string;
  description: string;
  entityID: number;
  entityKey: string;
  fieldValuePairs: any;
  hasChildren: boolean;
  icon: string;
  isAdhoc: boolean;
  isDashboard: boolean;
  isEditable: boolean;
  isExternal: boolean;
  isFavorite: boolean;
  level: number;
  mode: string;
  name: string;
  nodeId: number;
  nodeType: number;
  parentId: number;
  pathDir: string;
  query: string;
  seqNo: number;
  summary: boolean;

  constructor(name: string, tabId: number, windowId: number, recordId: string | number) {
    this.componentId = tabId;
    this.cssColor = null;
    this.description = null;
    this.entityID = windowId;
    this.entityKey = recordId + '';
    this.fieldValuePairs = null;
    this.hasChildren = false;
    this.icon = null;
    this.isAdhoc = false;
    this.isDashboard = false;
    this.isEditable = false;
    this.isExternal = false;
    this.isFavorite = false;
    this.level = 0;
    this.mode = 'UNSPECIFIED';
    this.name = name;
    this.nodeId = 0;
    this.nodeType = 1;
    this.parentId = 0;
    this.pathDir = null;
    this.query = null;
    this.seqNo = 0;
    this.summary = false;
  }
}
